type InfoIconProps = {
  size?: number;
};

function InfoIcon({ size = 14 }: InfoIconProps): JSX.Element {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" focusable="false">
      <path d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1Zm0 1a6 6 0 1 1 0 12A6 6 0 0 1 8 2Zm-.75 2.5h1.5V6h-1.5V4.5Zm0 2.75h1.5v4.25h-1.5V7.25Z" />
    </svg>
  );
}

export default InfoIcon;
